import { Close } from '../../../../../../Icons';
import { type UploadStatus } from '../../../../index';
import { FileUploadStatusIcon } from '../../../FileuploadStatusIcon/FileUploadStatusIcon';
import { IconButton } from '../../../../../IconButton';
import {
  FileListItem,
  FileUploadRowDivider,
  FileUploadRowLabel,
  FileUploadRowLabelWrapper,
  FileUploadStatusIconCloseWrapper,
} from './styles';

export const FileUploadRow = ({
  fileObj,
  uploadStatus,
  handleRemoveFile,
  hideDivider,
}: {
  fileObj: { id: string; file: File };
  uploadStatus: UploadStatus;
  handleRemoveFile: (fileId: string) => void;
  hideDivider: boolean;
}) => {
  const isUploading = uploadStatus === 'uploading';

  return (
    <FileListItem>
      <FileUploadRowLabelWrapper>
        <FileUploadRowLabel title={fileObj.file.name}>{fileObj.file.name}</FileUploadRowLabel>

        <FileUploadStatusIconCloseWrapper>
          <FileUploadStatusIcon uploadStatus={uploadStatus} />

          <IconButton
            variant="secondary"
            disabled={isUploading}
            onClick={() => {
              handleRemoveFile(fileObj.id);
            }}
          >
            <Close />
          </IconButton>
        </FileUploadStatusIconCloseWrapper>
      </FileUploadRowLabelWrapper>

      {!hideDivider && <FileUploadRowDivider />}
    </FileListItem>
  );
};
